import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-templating';
import { transient } from "aurelia-dependency-injection";

@autoinject
@transient()
export class Loading {
    
    @bindable
    public isLine: boolean;
}
